export const getArrayIsNotEmpty = (incomingArray) => {
    const isArray = Array.isArray(incomingArray);

    if (!isArray) {
        throw new Error('Provided invalid argument for array');
    };

    const arrayLength = incomingArray.length;

    if (arrayLength === 0) {
        return false;
    }

    else {
        return true;
    };
};